import React, { Component } from 'react'
import HeaderTmp from '../Template/HeaderTmp'
import FacebookLogin from 'react-facebook-login'
import { Layout, Row } from 'antd'
import { gql, graphql } from 'react-apollo'
import Submission from './Submission'
const { Content } = Layout

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLogin: false,
        }
    }
    responseFacebook = (response) => {
        if(response.accessToken) {
            this.setState({
                isLogin: true,
                facebook: response
            })
        }
    }

    render () {
        if(!this.props.data.event) {
            return <div>Loading...</div>
        }
        let { event } = this.props.data
        return (
            <Layout style={{ background: "#ffffff" }}>
                <HeaderTmp />
                <Content style={{ padding: '0 50px', marginTop: 100 }}>
                    <Row>
                        {this.state.isLogin?
                        <Submission event={event} facebook={this.state.facebook} />:
                        <FacebookLogin
                            appId={process.env.REACT_APP_APP_ID}
                            autoLoad={false}
                            scope="publish_actions,email,public_profile,manage_pages,publish_pages"
                            callback={this.responseFacebook}
                        />}
                    </Row>
                </Content>
            </Layout>
        )
    }
}

const PageQuery = gql`
    query queryEvent($slug: String){
        event(filter: {
            slug: $slug
        }){
            event
            slug
            title
            partner
            logoImage
            exampleCheckpoint
            message {
                signupMessage
            }
            _id
        }
    }
`

// export default Page
export default graphql(PageQuery, {
    options: (props) => ({
        variables: {
            slug: props.match.params.slug
        }
    })
})(Page)


// WEBPACK FOOTER //
// ./src/Page/Page.js